export interface ExportOrderError {
  errorCode: string | null;
  status?: number;
  message: string;
  technicalMessage?: string;
}

const exportOrderErrorMessages: Record<string, string> = {
  ORDER_WRONG_CLIENT_TYPE: "Ordern tillhör en annan klienttyp och kan inte exporteras.",
  ORDER_NOT_FOUND: "Ordern kunde inte hittas i databasen, vänligen kontakta support.",
  FLEET_ORDER_NOT_FOUND: "Ordern är inte en giltig Fleet-order.",
  FLEET_ORDER_EXTERNAL_ID_NOT_FOUND: "Ingen matchande order hittades.",
  FLEET_ORDER_RETRIEVER_NOT_FOUND: "Ingen matchande order hittades.",
  ORDER_NO_ARTICLES: "Ordern saknar artiklar och kan inte exporteras.",
  ORDER_PRICES_NOT_SET: "Alla priser måste sättas innan export.",
  ORDER_MISSING_CUSTOMER: "Kunduppgifter saknas för ordern.",
  ORDER_NO_SALES_PRICE: "Försäljningspris saknas.",
  ARTICLE_NO_STOCK_INFO: "Lagersaldo saknas för en eller flera artiklar.",
  ARTICLE_INSUFFICIENT_STOCK: "Otillräckligt lagersaldo för en eller flera artiklar.",
};

const SERVICE_UNAVAILABLE_MESSAGE = "Kunde inte nå exporttjänsten just nu, försök igen om en stund.";
const GENERIC_MESSAGE = "Något gick fel vid export. Kontakta support om felet kvarstår.";

export const STOCK_ERROR_CODES = ["ARTICLE_NO_STOCK_INFO", "ARTICLE_INSUFFICIENT_STOCK"];

const parseBody = (data: any): any => {
  if (typeof data === "string") {
    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  }
  return data;
};

// Case-insensitive lookup, also checks ProblemDetails "extensions".
const readString = (data: any, key: string): string | null => {
  if (!data || typeof data !== "object") return null;
  const sources = [data, data.extensions, data.Extensions];
  for (const source of sources) {
    if (!source || typeof source !== "object") continue;
    const match = Object.keys(source).find((k) => k.toLowerCase() === key.toLowerCase());
    if (match && typeof source[match] === "string" && source[match].trim() !== "") {
      return source[match].trim();
    }
  }
  return null;
};

export const mapExportOrderError = (err: any): ExportOrderError => {
  const status: number | undefined = err?.response?.status;
  const data = parseBody(err?.response?.data);
  const errorCode = readString(data, "errorCode")?.toUpperCase() ?? null;
  const errorType = readString(data, "errorType")?.toUpperCase() ?? null;
  const technicalMessage: string | undefined =
    readString(data, "clientMessage") || err?.message || undefined;

  if (!errorCode) console.warn("Export error without errorCode", err?.response?.data ?? err);

  let message: string;
  if (errorCode && exportOrderErrorMessages[errorCode]) {
    message = exportOrderErrorMessages[errorCode];
  } else if (errorType && exportOrderErrorMessages[errorType]) {
    message = exportOrderErrorMessages[errorType];
  } else if (status === 503) {
    message = SERVICE_UNAVAILABLE_MESSAGE;
  } else {
    message = GENERIC_MESSAGE;
  }

  return { errorCode, status, message, technicalMessage };
};
